import { faArrowRight, faCalendarLines } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space, Typography } from "antd"
import dayjs from "dayjs"
import VSpace from "../common/VSpace"
import { getRangeName, ReportFilterViewModel } from "./datacenterModel"

const { Text } = Typography

type Props = {
  filterItem: ReportFilterViewModel
}

const ReportFilterDateDetails = ({ filterItem }: Props) => {
  return <VSpace>
    <Text strong>{filterItem.name}</Text>
    {
      filterItem.filters.dateRange !== 'custom' && filterItem.filters.dateRange && <Text type='secondary'><FontAwesomeIcon icon={faCalendarLines} /> {getRangeName(filterItem.filters.dateRange)}</Text>
    }
    {
      filterItem.filters.dateRange === 'custom' && <Space>
        <Text type='secondary'><FontAwesomeIcon icon={faCalendarLines} /> {dayjs(filterItem.filters.startDate).format('MMM D, YYYY')}</Text>
        <FontAwesomeIcon icon={faArrowRight} />
        <Text type='secondary'><FontAwesomeIcon icon={faCalendarLines} /> {dayjs(filterItem.filters.endDate).format('MMM D, YYYY')}</Text>
      </Space>
    }
  </VSpace>
}

export default ReportFilterDateDetails